import { useEffect } from 'react'
import { FieldValues, Path, UseFormReturn } from 'react-hook-form'

import { FormError, toStringWithoutRepeat } from '@/services/fetch'

type FormErrorHandlerProps<T extends FieldValues> = {
  form: UseFormReturn<T>
  formErrors: FormError[]
  isError: boolean
  isSuccess: boolean
}

function useFormErrorHandler<T extends FieldValues>({
  form,
  formErrors,
  isError,
  isSuccess,
}: FormErrorHandlerProps<T>) {
  useEffect(() => {
    if (!isError) return

    formErrors
      .filter(({ key }) => !!form.getValues(key as Path<T>))
      .forEach(({ key, messages }) =>
        form.setError(key as Path<T>, {
          message: toStringWithoutRepeat(messages),
        }),
      )
  }, [form, formErrors, isError])

  useEffect(() => {
    if (!isSuccess) return

    form.reset()
  }, [isSuccess, form])
}

export { useFormErrorHandler }
